import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  dlRcDetails: {},
  evDetails: {},
  dlRcRejectionReasons: [],
  currentActiveFeId: "",
  dlRcDocTypes: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_DLRC_DETAILS:
      return setDlRcDetails(state, action);
    case ActionTypes.SET_EV_DETAILS:
      return setEvDetails(state, action);
    case ActionTypes.SET_DLRC_ADDITIONAL_DATA:
      return setDlRcAdditionalData(state, action);
    case ActionTypes.SET_DLRC_CURRENT_FEID:
      return setCurrentFeId(state, action);
    case ActionTypes.RESET_STATE_DLRC:
      return resetStateDlRc(state, action);
    default:
      return state;
  }
}

const setDlRcDetails = (state, action) => {
  return {
    ...state,
    dlRcDetails: action.payload,
  };
};

const setEvDetails = (state, action) => {
  return {
    ...state,
    evDetails: action.payload,
  };
};

const setDlRcAdditionalData = (state, action) => {
  return {
    ...state,
    dlRcRejectionReasons: action.payload.reasons,
    dlRcDocTypes: action.payload.doc_types,
    evAdditionalData: action.payload.ev_data,
  };
};

const setCurrentFeId = (state, action) => {
  return {
    ...state,
    currentActiveFeId: action.payload.feid,
  };
};

const resetStateDlRc = (state, action) => {
  // reset specific key if given else reset complete state
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};
